import { Pagination } from "../common/table_main";
import { DocumentResponse, DocumentSummaryResponse } from "./document.model";

export interface DocumentState {
    data: DocumentResponse[] | null;
    pagination: Pagination | null;
    loading: boolean;
    error: boolean;
    errorMessage: string | null;
}

export interface SummaryState {
    data: DocumentSummaryResponse[] | null;
    pagination: Pagination | null;
    loading: boolean;
    error: boolean;
    errorMessage: string | null;
}

export const documentInitialState: DocumentState = {
    data: null,
    pagination:null,
    loading: false,
    error: false,
    errorMessage: null,
};

export const summaryInitialState: SummaryState = {
    data: null,
    pagination: null,
    loading: false,
    error: false,
    errorMessage: null,
};
